import { render, staticRenderFns } from "./AccountInfoForm.vue?vue&type=template&id=156852e2&scoped=true"
import script from "./AccountInfoForm.vue?vue&type=script&lang=js"
export * from "./AccountInfoForm.vue?vue&type=script&lang=js"
import style0 from "./AccountInfoForm.vue?vue&type=style&index=0&id=156852e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156852e2",
  null
  
)

export default component.exports